module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAaUlEQVQ4y2NgGBxAu/4/WXjUAIQB/4/J/ScHY3WBtGPvf92AaWCaZC8IWXX8n7P27P8b91+DaRCfJAPkXPr+n7z05D8IgGgQn2QXVPTv/r9651UwTbILQJjNoOm/qE3Xfx7TVhLCYEgDAP60Idqcv6GeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NR.png
// module id = 1232
// module chunks = 0